module.exports = __webpack_public_path__ + "static/media/screenshot20.6b73d4df.png";